/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { resetQuotes } from '../../states/Store';

export default () => 
    <span onClick={() => resetQuotes()}>Reset</span>

